export default __webpack_public_path__ + "static/media/pdf.ffec88ca.svg";